import React, { useEffect } from 'react'
import styled from 'styled-components'

import Loader from '../../loader'
import ReviewList from '../../review-list'

import { useProfileReviews } from '../../../../data/hooks/reviews'
import { useScrollTrigger } from '../../../../data/hooks/interface/scroll-trigger'


type ProfileReviewsProps = {
  publicId: string
}

const ProfileReviews: React.FunctionComponent<ProfileReviewsProps> = ({ publicId }) => {
    const [reviewsState, loadReviews] = useProfileReviews(publicId!)
    const [_, setScrollable] = useScrollTrigger({
        bottomStopCondition: () => reviewsState.final || reviewsState.pending,
        onBottomReached: () => loadReviews(reviewsState?.reviews?.length || 0, 20),
    })

    useEffect(() => {
        loadReviews(0, 10)
    }, [publicId])

    return (
        <Container ref={r => setScrollable(r)}>
            <ReviewList focus={'book'} reviews={reviewsState.reviews} emptyState='The user has not left a review yet' final={reviewsState.final} />
            {reviewsState.pending && <Loader />}
        </Container>
    )
}

const Container = styled.div`
  display: grid;
  justify-items: center;
  align-items: center;

  width: 100%;
  max-width: 100%;

  /* overflow-x: hidden; */
`


export default ProfileReviews